<div
  class="color-strip"
  [style.background-color]="viewModel.cardAccentColor$ | async"
  [class.on-perforated-paper]="cardBackground?.section | method: 'isOnPerforatedPaper'"></div>
<div class="main-content" [style.background-color]="viewModel.cardColor$ | async">
  <app-print-card-background-image-with-color-overlay-and-opacity [cardBackground]="cardBackground">
  </app-print-card-background-image-with-color-overlay-and-opacity>
</div>
